import styled from 'styled-components'

const DefaultButton = ({ theme }) => ({
    borderRadius: '500px',
    padding: '16px 36px',
    width: '100%',
    fontSize: 14,
    border: 'none',
    cursor: "pointer",
    fontWeight: 600,
    [theme.breakpoint.lg()]: {
        width: 'fit-content',
        fontSize: 16,
    },

    ':disabled': {
        opacity: 0.4
    }
})

const PrimaryButton = ({ theme }) => ({
    background: 'linear-gradient(215.68deg, #87BAFF -80.44%, #005FC8 81.35%)',
    color: theme.color.neutral["08"],
})

const SecondaryButton = ({ theme }) => ({
    background: 'linear-gradient(224deg, #FFA600 -11.69%, #F36800 100%)',
    color: theme.color.neutral["08"],
})

const TertiaryButton = ({ theme }) => ({
    background: theme.color.neutral['08'], 
    color: theme.color.brandPrimary.light 
})

const MutedButton = ({ theme }) => ({
    border: `1px solid ${ theme.color.neutral['08']}`,
    color: theme.color.neutral['08'],
    background: 'transparent'
})

const MutedPrimaryButton = ({ theme }) => ({
    border: `1px solid ${ theme.color.brandPrimary.light}`,
    color: theme.color.brandPrimary.light,
    background: 'transparent'
})

const ThemeFactory = (variant, { theme }) => {
    const variants = {
        'primary': {...PrimaryButton({ theme })},
        'secondary': { ...SecondaryButton({ theme })},
        'tertiary': {...TertiaryButton({theme})},
        'muted': {...MutedButton({ theme })},
        'muted-primary': {...MutedPrimaryButton({ theme })},
        '': {}
    }

    return variants[variant]
}

const StyledButton = styled.button(({ theme, variant }) => ({
    ...DefaultButton({ theme }),
    ...ThemeFactory(variant, { theme }),
}))

export default StyledButton